import React from 'react';
import { Box, Chip } from '@mui/material';
import { DataSource, ShowAs, GroupBy, DateRange } from '../hooks/useChartData';

interface FilterChipsProps {
  onPresetSelect: (preset: {
    dataSource: DataSource;
    showAs: ShowAs;
    groupBy: GroupBy;
    dateRange: DateRange;
  }) => void;
}

interface PresetFilter {
  id: string;
  label: string;
  dataSource: DataSource;
  showAs: ShowAs;
  groupBy: GroupBy;
  dateRange: DateRange;
}

const PRESET_FILTERS: PresetFilter[] = [
  {
    id: 'monthly-avg-time-to-hire-published',
    label: 'Time to Hire from Published Date',
    dataSource: 'jobs',
    showAs: 'average_time',
    groupBy: 'published_to_hired',
    dateRange: 'last_12_months'
  },
  {
    id: 'monthly-avg-time-to-hire-first-application',
    label: 'Time to Hire from First Application',
    dataSource: 'jobs',
    showAs: 'average_time',
    groupBy: 'first_application_to_hired',
    dateRange: 'last_12_months'
  },
  {
    id: 'monthly-job-count-by-location',
    label: 'Job Count by Location',
    dataSource: 'jobs',
    showAs: 'count',
    groupBy: 'location',
    dateRange: 'last_12_months'
  },
  {
    id: 'monthly-job-count-by-state',
    label: 'Job Count by Job State',
    dataSource: 'jobs',
    showAs: 'count',
    groupBy: 'job_state',
    dateRange: 'last_12_months'
  },
  {
    id: 'monthly-application-count-by-status',
    label: 'Application Count by Status',
    dataSource: 'applications',
    showAs: 'count',
    groupBy: 'status',
    dateRange: 'last_12_months'
  }
];

export const FilterChips: React.FC<FilterChipsProps> = ({ onPresetSelect }) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 3, flexWrap: 'wrap' }}>
      {PRESET_FILTERS.map((preset) => (
        <Chip
          key={preset.id}
          label={preset.label}
          onClick={() => onPresetSelect(preset)}
          sx={{
            backgroundColor: '#f5f5f5',
            color: '#333',
            '&:hover': {
              backgroundColor: '#e0e0e0'
            },
            cursor: 'pointer'
          }}
        />
      ))}
    </Box>
  );
};
